import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { HelpLink } from '../../../../../components/common/HelpLink';
import { IButtonProps, IOuter } from '../../EmptyState.types';
import { WixIcons } from '../../../../../components/common';
import styles from './LearnMoreLink.scss';

export const LearnMoreLink: FC<IOuter & IButtonProps> = ({ link }) => (
  <HelpLink
    suffixIcon={<WixIcons.ExternalLinkSmall />}
    article={link}
    size="small"
    skin="standard"
    priority="secondary"
    className={styles.link}
    dataHook="learn-more-button"
  >
    <FormattedMessage id="common.learn-more" />
  </HelpLink>
);
